import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAlert,_vm._g(_vm._b({staticStyle:{"background":"#eeeeee"},attrs:{"border":"left","colored-border":"","icon":_vm.icon,"color":_vm.$attrs['color'] || '#6a6af4'},on:{"input":function (v) { return _vm.$emit('input', v); }}},'v-alert',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }